import {i18n} from '@yourcoach/i18n';

import type {Variant} from '../ToolBoxButton/types';

export const getDescription = (variant: Variant) => {
  switch (variant) {
    case 'food_diary':
      return i18n.t('shared:food_diary.banner.description');
    case 'trackers':
      return i18n.t('shared:track_your_weight');
    default:
      return '';
  }
};
